import React from "react";
import { fmtCurrency } from "../helpers";

export default ({ data }) => {
  return (
    <>
      <h3 className="friends-hdg">
        <i className="fa fa-thermometer-empty fa-lg" />
        <span>{`${data.friendFname}’s Fundraising Goals`}</span>
      </h3>

      <p>{data.friendText}</p>

      <div
        style={{
          background: `linear-gradient(to right, #ebf5fa ${data.percent}, 0%, #ffffff ${data.remainder})`,
          height: "35px",
          border: "1px solid #d3e9f3",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <b style={{ color: "#007cba", fontSize: "1.1rem" }}>{data.percent}</b>
      </div>

      <div
        style={{
          marginTop: "15px",
          textAlign: "center",
          fontSize: "1.25rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <b>{data.number}</b>
        <span
          style={{
            paddingLeft: "7.5px",
            paddingRight: "7.5px",
            paddingBottom: "2px",
            fontSize: "1.05rem",
          }}
        >
          {parseInt(data.number, 10) === 1
            ? "donor has contributed"
            : "donors have contributed"}
        </span>
        <b>{fmtCurrency(data.pledged / 100)}</b>
        <span
          style={{
            paddingLeft: "7.5px",
            paddingRight: "7.5px",
            fontSize: "1.05rem",
            paddingBottom: "2px",
          }}
        >
          towards my
        </span>
        <b>{fmtCurrency(data.goal / 100, 0)}</b>
        <span
          style={{
            paddingLeft: "7.5px",
            fontSize: "1.05rem",
            paddingBottom: "2px",
          }}
        >
          goal
        </span>
      </div>
    </>
  );
};
